import { useCallback, useState } from 'react';

type Discount = {
  discountCode?: string | null;
  tmp?: number;
};

const initialState = {
  discountInitialState: {},
  isApplyingDiscount: false,
};

export const useDiscount = () => {
  const [discountInitialState, setDiscountInitialState] = useState<Discount>(initialState.discountInitialState);
  const [isApplyingDiscount, setIsApplyingDiscount] = useState(initialState.isApplyingDiscount);

  const clearDiscount = useCallback(async () => {
    setDiscountInitialState(initialState.discountInitialState);
    setIsApplyingDiscount(initialState.isApplyingDiscount);
  }, []);

  return { clearDiscount, discountInitialState, isApplyingDiscount, setDiscountInitialState, setIsApplyingDiscount };
};
